module.exports = __webpack_public_path__ + "img/nuve-logo.d6172255.png";